export const getTaskStatus = (tasks) => {
    if (!tasks || !Object.keys(tasks).length) return;
    const remainngTasks = Object.keys(tasks)
    
    .filter(taskProperty => !tasks[taskProperty]).length
    return {
        total: tasks.length - 1,
        completed: tasks.length - remainngTasks - 1,
        left: remainngTasks - 1,
    }
}